module.exports = __webpack_public_path__ + "static/media/splash-screen-1.8666d6cf.png";